import React from 'react'
import { Navigate, useParams } from 'react-router-dom'
import AiHero from '../../Components/Automation/AiHero'
import WhyAIAutomation from '../../Components/Automation/WhyAIAutomation'
import TechServicesSection from '../../Components/Automation/TechServicesSection'
import IndustriesWeServe from '../../Components/Automation/IndustriesWeServe'
import WhyPartnerWithUs from '../../Components/Automation/WhyPartnerWithUs'
import Banner from '../../Components/Banner'
import { Helmet } from 'react-helmet-async'
import FoundationSection from './ai/FoundationSection'
import { aiAutomationPagesData } from '../../data/aiAutomationPagesData'
import ContactSection from '../../Components/home/ContactSection'

function ConversationalAI() {
    const { slug } = useParams();
    const page = aiAutomationPagesData[slug];

    if (!page) {
        return <Navigate to="/404" replace />;
    }
    return (
        <div>
            <Helmet>
                <title>{page.seo.title}</title>
                <meta name="description" content={page.seo.description} />
                <meta name="keywords" content={page.seo.keywords} />
                <link rel="canonical" href={page.seo.canonical} />
                <meta property="og:title" content={page.seo.ogTitle} />
                <meta property="og:description" content={page.seo.ogDescription} />
                <meta property="og:url" content={page.seo.ogUrl} />
                <meta property="og:type" content={page.seo.ogType} />
                <meta property="og:image" content={page.seo.ogImage} />
                <meta name="twitter:card" content={page.seo.twitterCard} />
                <meta name="twitter:title" content={page.seo.twitterTitle} />
                <meta name="twitter:description" content={page.seo.twitterDescription} />
                <meta name="twitter:image" content={page.seo.twitterImage} />
            </Helmet>

            {/* Hero Section */}
            {page?.hero?.title && (
                <AiHero
                    title={page.hero.title}
                    text={page.hero.text}
                    imgData={page.hero.imgData}
                />
            )}

            {/* Introduction Section - Original UI Preserved */}
            {page?.foundation?.title && (
                <FoundationSection
                    title={page.foundation.title}
                    description={page.foundation.description}
                    imageSrc={page.foundation.imageSrc}
                    imageAlt={page.foundation.imageAlt}
                />
            )}

            {/* Why Conversational AI */}
            {page?.whyAiAutomation?.features && page.whyAiAutomation.features.length > 0 && (
                <WhyAIAutomation
                    heading={page.whyAiAutomation.heading}
                    desc={page.whyAiAutomation.desc}
                    approachData={page.whyAiAutomation.features}
                />
            )}

            {/* Conversational AI Service Offerings */}
            {page?.techServices?.services && page.techServices.services.length > 0 && (
                <TechServicesSection
                    heading={page.techServices.heading}
                    deliverables={page.techServices.services}
                />
            )}

            {/* Existing Components Preserved */}
            {page?.industries?.items && page.industries.items.length > 0 && (
                <IndustriesWeServe
                    heading={page.industries.heading}
                    steps={page.industries.items}
                />
            )}
            {((page?.whyPartner?.faqData && page.whyPartner.faqData.length > 0)) && (
                <WhyPartnerWithUs
                    heading={page.whyPartner.heading}
                    faqData={page.whyPartner.faqData}
                />
            )}

            {/* Bottom Banner */}
            {/* {page?.banner?.title && (
                <Banner
                    title={page.banner.title}
                    text={page.banner.text}
                />
            )} */}
            <ContactSection/>
        </div>
    )
}

export default ConversationalAI;